import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDDisplayText, FDHeadlineText,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { Layout } from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .done();

const TaxFilingPartnerPage = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

TaxFilingPartnerPage.defaultProps = {
};

TaxFilingPartnerPage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { TaxFilingPartnerPage };
